'use client'

import Link from 'next/link'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHiveUserLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom'
import { faEye, faEyeSlash } from '@awesome.me/kit-94e593bf23/icons/sharp/light'
import { faCheck } from '@awesome.me/kit-94e593bf23/icons/sharp/regular'

import PageTitle from '@/app/_components/PageTitle'
import Panel from '@/app/_components/Panel'
import OrderSummary from '@/app/_components/OrderSummary'
import AssistanceBlock from '@/app/_components/AssistanceBlock'
import ContinueShoppingLink from '@/app/_components/ContinueShoppingLink'

import CreateAccountForm from '@/app/(account)/account/_components/CreateAccountForm'
import ExpressCheckoutWrapper from '@/app/_components/ExpressCheckoutWrapper'

import { useCart } from '@/app/_lib/hooks'
import Price from '@/app/_components/Price'

const CreateAccount = ({ className }) => {

    const { cart, isLoading: cartLoading } = useCart()

    return (
        <>
            <section className="cart-checkout-topbar-mobile">
                <div className="flex items-center">
                    <FontAwesomeIcon icon={faHiveUserLight} className="text-dark text-nav-icon align-[0px] me-2" />
                    <h1 className="text-dark text-sm font-medium">Create Account</h1>
                </div>
                <div className="flex items-center">
                    <Price amount={cart?.orderTotal || 0} className="text-sm text-light" />
                </div>
            </section>
            <div className="site-padding">
                {/* Header section */}
                <div className="cart-checkout-topbar-desktop-wrapper">
                    <div className="cart-checkout-topbar-desktop-left">
                        <div className="flex items-center">
                            <FontAwesomeIcon icon={faHiveUserLight} className="text-xl text-primary mr-1" />
                            <h1 className="text-light text-xl font-extralight mr-6">Create Account</h1>
                        </div>
                    </div>
                    <div className="cart-checkout-topbar-desktop-right">
                        <ContinueShoppingLink className="text-light text-xs hover:text-primary" />
                    </div>
                </div>

                {/* Form and Order summary side by side */}
                <div className="cart-checkout-grid">
                    <section className="cart-checkout-content-area mb-8 md:mb-12 lg:mb-36">
                        <Panel label="Create Account">
                            <CreateAccountForm checkout={true} />
                        </Panel>
                    </section>
                    <section className="cart-checkout-sidebar">
                        <div className="cart-checkout-sidebar-inner flex flex-col">
                            <div className="order-2 mb-0 lg:order-1 lg:mb-4">
                                <OrderSummary cart={cart} showCartItems={true} displayCheckoutButton={true} />
                            </div>
                            <div className="order-1 mb-4 lg:order-2 lg:mb-0">
                                {cart && cart.subTotal > 0 &&
                                    <ExpressCheckoutWrapper
                                        expressCheckoutData={cart.expressCheckoutData}
                                    />
                                }
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    )
}

export default CreateAccount
